import * as React from 'react'
import { Block, Text, Button } from '$views/components'
import { Formik, Form, Field } from 'formik'
import { ResidentField } from '$views/RecommendationsForms/ResidenceForm/ResidentStep/components/ResidentField'
import { residenceFormDraftName, ResidenceFormSteps } from '$views/RecommendationsForms/ResidenceForm/ResidenceForm'
import { residentStepFormSchema } from '$views/RecommendationsForms/ResidenceForm/ResidentStep/ResidentStep.validator'
import { useFetch } from '$utils/hooks/useFetch'
import { Spinner } from '$views/components/Spinner'
import { Error } from '$views/components/Error'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { draft } from '$utils/services/formDraftService'
import { residentsServices } from '$services/nursingHome'
import { Resident } from '$domain/model/nursingHome/residents/residents.model'

interface Props {
  onNextStep: () => void
  onPreviousStep: () => void
}

export const ResidentStep: React.FC<Props> = ({ onNextStep, onPreviousStep }) => {
  const [initialValues, setIntialValues] = React.useState(undefined)
  const { response, error, showErrorNotification, loading } = useFetch<Resident[]>(residentsServices.getResidentsList)

  React.useEffect(() => {
    const draftValues = draft.get(residenceFormDraftName)
    if (draftValues && draftValues[ResidenceFormSteps.residentStep]) {
      setIntialValues({ [ResidenceFormSteps.residentStep]: draftValues[ResidenceFormSteps.residentStep].id })
    }
  }, [])

  const getResidents = () => {
    if (response) {
      const updatedResidents = response.map(resident => {
        return {
          label: resident.name,
          value: resident.id,
        }
      })
      return updatedResidents
    }
    return [{ label: '', value: '' }]
  }

  const redirectToMyService = () => history.push(routeProvider.myServices)

  if (showErrorNotification) {
    return <Error error={error} onClick={redirectToMyService} />
  }

  return (
    <>
      {loading && <Spinner />}
      <Text title>3. Quién</Text>
      <Text marginTop="base" marginBottom="small">
        Elige al residente para el que necesitas el servicio
      </Text>
      <Block marginTop="small">
        <Formik
          initialValues={initialValues}
          onSubmit={onNextStep}
          validateOnChange={true}
          validationSchema={residentStepFormSchema}
          render={() => (
            <Form>
              <Field
                component={ResidentField}
                name={ResidenceFormSteps.residentStep}
                list={getResidents()}
                draftName={residenceFormDraftName}
              />
              <Block flex marginTop="medium">
                <Block marginRight="base">
                  <Button primary bordered onClick={onPreviousStep}>
                    Volver
                  </Button>
                </Block>
                <Button primary fluid type="submit">
                  Siguiente
                </Button>
              </Block>
              <Text marginTop="mini" color="menu" textAlign="center">
                Paso 3/4
              </Text>
            </Form>
          )}
        />
      </Block>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/ResidentStep/ResidentStep.tsx